module.exports = __webpack_public_path__ + "img/voice-icon6.55dbdb0.png";